import React, {useState, useEffect} from 'react';
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@mui/material";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import "./AddEmployeeForm.css";
import DictionaryTypeAdder from "./DictionaryTypeAdder";
import DictionaryTypeManager from "./DictionaryTypeAdder";

const RegionController = ({geoIds}) => {
    const [cities, setCities] = useState([]);
    const [regions, setRegions] = useState([]);
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedRegion, setSelectedRegion] = useState('');
    const [newCityName, setNewCityName] = useState('');
    const [selectedNewRegion, setSelectedNewRegion] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAddCityModalOpen, setIsAddCityModalOpen] = useState(false);
    const [newRegionName, setNewRegionName] = useState('');
    const [isAddRegionModalOpen, setIsAddRegionModalOpen] = useState(false);
    const [isAddRegionConfirmed, setIsAddRegionConfirmed] = useState(false);
    const [cityData, setCityData] = useState([]); // State to hold city data
    const [deleteCityId, setDeleteCityId] = useState(0);
    const isAddRegionDisabled = !newRegionName;
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [regionData, setRegionData] = useState([]);
    const [activeTab, setActiveTab] = useState('documentType');
    const [citySearchText, setCitySearchText] = useState('');
    const [regionSearchText, setRegionSearchText] = useState('');


    const handleDeleteCityClick = (id) => {
        setDeleteCityId(id);
        setIsDeleteModalOpen(true);
    };

    const handleDeleteConfirm = () => {
        const payload = {
            id: deleteCityId,
        };

        // Send a PUT request with the payload
        fetch(`${process.env.REACT_APP_API_BASE_URL}/DeleteDictionary`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((data) => {
                setIsDeleteModalOpen(false);
                setDeleteCityId(0);
                fetchCityData();
                fetchRegionData();
            })
            .catch((error) => {
                setIsDeleteModalOpen(false);
                setDeleteCityId(0);
            });
    };

    const handleDeleteCancel = () => {
        setIsDeleteModalOpen(false); // Close the delete confirmation modal
        setDeleteCityId(0); // Reset deleteCityId
    };

    const handleAddRegionConfirm = () => {
        setIsAddRegionConfirmed(true); // User confirmed to add the region
        handleOpenAddRegionModal(); // Open the modal
    };

    const handleNewRegionNameChange = (event) => {
        setNewRegionName(event.target.value);
    };

    const handleOpenAddRegionModal = () => {
        setIsAddRegionModalOpen(true);
    };

    const handleCloseAddRegionModal = () => {
        setIsAddRegionModalOpen(false);
    };

    const handleAddRegion = () => {
        const payload = {
            dictionaryTypeId: 3,
            dictionaryname: newRegionName,
            dictionaryId: null,
        };

        fetch(`${process.env.REACT_APP_API_BASE_URL}/AddNewDictionary`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((data) => {
                setNewRegionName('');
                handleCloseAddRegionModal();
                fetchRegionData(); // Re-fetch region data
                fetchCityData();
            })
            .catch((error) => {
                handleCloseAddRegionModal();
            });
    };

    const fetchCityData = () => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionary?DictionaryTypeId=2`)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    const reversedCities = data.data.reverse(); // Reverse the cities data
                    setCities(reversedCities);
                    setCityData(reversedCities); // Set the city data in the state
                }
            })
            .catch(error => console.error('Error fetching cities:', error));
    };

    const fetchRegionData = () => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionary?DictionaryTypeId=3`)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    const reversedRegions = data.data.reverse(); // Reverse the regions data
                    setRegionData(reversedRegions);
                    setRegions(reversedRegions);
                }
            })
            .catch(error => console.error('Error fetching regions:', error));
    };

    useEffect(() => {
        fetchCityData();
        fetchRegionData();
    }, []);

    const handleCityChange = (event) => {
        setSelectedCity(event.target.value);
    };

    const handleRegionChange = (event) => {
        setSelectedRegion(event.target.value);
    };

    const handleNewCityChange = (event) => {
        setNewCityName(event.target.value);
    };

    const handleNewRegionChange = (event) => {
        setSelectedNewRegion(event.target.value);
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };
    const filteredCityData = cityData.filter(city =>
        city.typesName.toLowerCase().includes(citySearchText.toLowerCase())
    );

    const filteredRegionData = regionData.filter(region =>
        region.typesName.toLowerCase().includes(regionSearchText.toLowerCase())
    );

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleOpenAddCityModal = () => {
        setIsAddCityModalOpen(true);
    };

    const handleCloseAddCityModal = () => {
        setIsAddCityModalOpen(false);
    };

    const handleConfirm = () => {
        const city = cities.find(c => c.id === selectedCity);
        const payload = {
            id: selectedCity,
            categoryID: 2,
            name: city ? city.typesName : '',
            dictionaryId: selectedRegion
        };

        fetch(`${process.env.REACT_APP_API_BASE_URL}/EditDictionary`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                setSelectedCity('');
                setSelectedRegion('');
                fetchRegionData();
                fetchCityData()

                handleCloseModal();
            })
            .catch((error) => {
                handleCloseModal();
            });
    };

    const handleAddCityConfirm = () => {
        const payload = {
            dictionaryTypeId: 2,
            dictionaryname: newCityName,
            dictionaryId: selectedNewRegion
        };

        fetch(`${process.env.REACT_APP_API_BASE_URL}/AddNewDictionary`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                setNewCityName('');
                setSelectedNewRegion('');
                handleCloseAddCityModal();
                fetchCityData();
                fetchRegionData();
            })
            .catch((error) => {
                handleCloseAddCityModal();
            });
    };

    const isSubmitDisabled = !selectedCity || !selectedRegion;
    const isAddCityDisabled = !newCityName || !selectedNewRegion;

    return (
        <div className="add-city-type-formm">

            {/*<div className="tab-navigation">*/}
            {/*    <button*/}
            {/*        className={activeTab === 'fileType' ? 'active-tab' : ''}*/}
            {/*        onClick={() => setActiveTab('fileType')}*/}
            {/*    >*/}
            {/*        ქალაქები*/}
            {/*    </button>*/}
            {/*    <button*/}
            {/*        className={activeTab === 'documentType' ? 'active-tab' : ''}*/}
            {/*        onClick={() => setActiveTab('documentType')}*/}
            {/*    >ცნობარი*/}
            {/*    </button>*/}
            {/*</div>*/}
            {activeTab === 'fileType' && (
                <div>
                    <div className={"cities-container"}>
                        <div>
                            <FormControl fullWidth>
                                <InputLabel id="cities-label">ქალაქები</InputLabel>
                                <Select labelId="cities-label" value={selectedCity} label="ქალაქები"
                                        onChange={handleCityChange}>
                                    {cities.map((city) => (
                                        <MenuItem key={city.id} value={city.id}>{city.typesName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth style={{marginTop: 20}}>
                                <InputLabel id="regions-label">რეგიონები</InputLabel>
                                <Select labelId="regions-label" value={selectedRegion} label="რეგიონები"
                                        onChange={handleRegionChange}>
                                    {regions.map((region) => (
                                        <MenuItem key={region.id} value={region.id}>{region.typesName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{marginTop: 20, marginBottom: 30}}
                                onClick={handleOpenModal}
                                disabled={isSubmitDisabled}
                            >
                                ქალაქის და რეგიონის მიბმა
                            </Button>
                            <ConfirmationModal
                                isOpen={isModalOpen}
                                onRequestClose={handleCloseModal}
                                onConfirm={handleConfirm}
                            />
                        </div>
                        <div>
                            <TextField
                                fullWidth
                                label="ქალაქის სახელი"
                                value={newCityName}
                                onChange={handleNewCityChange}
                            />
                            <FormControl fullWidth style={{marginTop: 20}}>
                                <InputLabel id="new-regions-label">რეგიონები</InputLabel>
                                <Select labelId="new-regions-label" value={selectedNewRegion} label="რეგიონები"
                                        onChange={handleNewRegionChange}>
                                    {regions.map((region) => (
                                        <MenuItem key={region.id} value={region.id}>{region.typesName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{marginTop: 20}}
                                onClick={handleOpenAddCityModal}
                                disabled={isAddCityDisabled}
                            >
                                ახალი ქალაქის დამატება
                            </Button>
                            <ConfirmationModal
                                isOpen={isAddCityModalOpen}
                                onRequestClose={handleCloseAddCityModal}
                                onConfirm={handleAddCityConfirm}
                            />
                        </div>
                        <div>
                            <TextField
                                fullWidth
                                label="ახალი რეგიონის სახელი"
                                value={newRegionName}
                                onChange={handleNewRegionNameChange}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                style={{marginTop: 20}}
                                onClick={handleAddRegionConfirm}
                                disabled={isAddRegionDisabled}
                            >
                                ახალი რეგიონის დამატება
                            </Button>
                            <ConfirmationModal
                                isOpen={isAddRegionModalOpen}
                                onRequestClose={handleCloseAddRegionModal}
                                onConfirm={() => {
                                    if (isAddRegionConfirmed) {
                                        handleAddRegion(); // Add region if confirmed
                                    }
                                    setIsAddRegionConfirmed(false); // Reset the confirmation flag
                                }}
                            />
                        </div>
                    </div>
                    <div style={{display: "flex", gap: 20}}>


                        <TableContainer component={Paper}>

                            <h3>&nbsp;&nbsp;&nbsp;ქალაქები:</h3>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell> <TextField
                                            fullWidth
                                            label="ქალაქი"
                                            value={citySearchText}
                                            onChange={(e) => setCitySearchText(e.target.value)}
                                            style={{marginBottom: 20}}
                                        /></TableCell>
                                        <TableCell>რეგიონი</TableCell>
                                        <TableCell>ქმედება</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredCityData.map((city) => (
                                        <TableRow key={city.id}>
                                            <TableCell>{city.id}</TableCell>
                                            <TableCell>{city.typesName}</TableCell>
                                            <TableCell>
                                                {city.dictionaryId !== null ?
                                                    regionData.find(region => region.id === city.dictionaryId)?.typesName
                                                    : ''}
                                            </TableCell>
                                            <TableCell>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => handleDeleteCityClick(city.id)}
                                                >
                                                    წაშლა
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                            <ConfirmationModal
                                isOpen={isDeleteModalOpen}
                                onRequestClose={handleDeleteCancel}
                                onConfirm={handleDeleteConfirm}
                            />
                        </TableContainer>
                        <TableContainer component={Paper}>\
                            <h3>&nbsp;&nbsp;&nbsp;რეგიონები:</h3>
                            <Table>

                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell><TextField
                                            fullWidth
                                            label="რეგიონი"
                                            value={regionSearchText}
                                            onChange={(e) => setRegionSearchText(e.target.value)}
                                            style={{marginBottom: 20}}
                                        /></TableCell>
                                        <TableCell>ქმედება</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredRegionData.map((region) => (
                                        <TableRow key={region.id}>
                                            <TableCell>{region.id}</TableCell>
                                            <TableCell>{region.typesName}</TableCell>
                                            <TableCell>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => handleDeleteCityClick(region.id)}
                                                >
                                                    წაშლა
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </div>
                </div>
            )}

            {activeTab === 'documentType' && (
                <DictionaryTypeAdder geoIds={geoIds}/>

            )}
        </div>
    );
};

export default RegionController;
